import * as types from 'features/telematics/telematicAccountsActions';
import {TelematicProviderTypeMetadata} from 'types';


export type CompanyTelematicAccountState = {
    accounts: TelematicProviderTypeMetadata[],
    loading: boolean,
    succeeded: boolean,
    error: any
}

export const defaultState = {
    accounts: [],
    loading: false,
    succeeded: false,
    error: null
};

export default function companyTelematicAccounts(state: CompanyTelematicAccountState = defaultState, action: any): CompanyTelematicAccountState {
    switch (action.type) {
        case types.REQUEST_COMPANY_TELEMATIC_ACCOUNTS_START:
            return {
                ...state,
                loading: true,
                succeeded: false,
                error: null
            };

        case types.REQUEST_COMPANY_TELEMATIC_ACCOUNTS_COMPLETED:
            return {
                ...state,
                accounts: (action.payload?.accounts ?? [])
                    .filter((a: TelematicProviderTypeMetadata)  => a != null),
                loading: false,
                succeeded: true,
                error: null
            };

        case types.REQUEST_COMPANY_TELEMATIC_ACCOUNTS_ERROR:
            return {
                ...state,
                loading: false,
                succeeded: false,
                error: action.error
            };

        default:
            return state;
    }
}
